// TODO LO QUE ES "LA SESIÓN", EN UN SOLO SITIO.
//
// Había dos limpiezas distintas y no limpiaban lo mismo, y eso costó una tarde entera:
//   · `logout()` borraba token, usuario Y el estado de "ver como" (rol o persona previsualizada).
//   · El interceptor de 401 de axios borraba SOLO token y usuario.
//
// Así que cuando una sesión caducaba con un "ver como" activo, quedaba media sesión en el navegador:
// al volver a entrar con las credenciales buenas, la aplicación se ponía otra vez en modo
// previsualización con el rol de OTRA persona, y las rutas rebotaban al que acababa de entrar. Desde
// fuera se ve exactamente como "no me deja acceder con mis datos" — y se arregla pulsando "Cerrar
// sesión", que era la única limpieza completa. Eso último es lo que lo delató.
//
// La lista vive aquí y la usan los dos. Una segunda lista en otro fichero es cómo volvería a pasar.
//
// Y VOLVIÓ A PASAR (19-ago-2026), tal cual lo predecía la línea de arriba: la pantalla de bloqueo
// definía SUS claves en su propio fichero, fuera de esta lista. Cuando el servidor mataba una
// sesión (token caducado, corte de seguridad), el interceptor limpiaba token y usuario… pero la
// marca de "bloqueado por el usuario X" sobrevivía. Al volver a entrar con credenciales buenas, la
// pantalla de bloqueo saltaba OTRA VEZ nada más entrar — desde fuera, "no me deja acceder salvo
// que cierre sesión y meta todo de cero". Las claves se definen AQUÍ y el bloqueo las importa:
// entrar con credenciales es prueba más fuerte que la contraseña del desbloqueo (es la misma), así
// que una sesión recién abierta nunca hereda el candado de la anterior.
export const CLAVE_BLOQUEO_MARCA = 'bloqueo_ultima_actividad';
export const CLAVE_BLOQUEO_ACTIVO = 'bloqueo_activo_de';

// ── Y LA QUINTA VEZ FUE AL REVES: LA MARCA SE QUEDA PUESTA Y NO HAY NINGUN CANDADO ──────────
//
//  EL SINTOMA, contado por el dueño el 14-sep-2026: «el sistema de documentos que hay que poner
//  contraseña, a los 10-15 segundos de haber puesto la contraseña me saca y me vuelve a pedir la
//  contraseña como si se hubiera cerrado la pestaña».
//
//  LA CAUSA: la puerta de los documentos personales se cierra si la pantalla esta bloqueada —lo
//  correcto: lo que hay dentro son nominas—, pero lo preguntaba mirando si EXISTE la clave
//  `bloqueo_activo_de` en el almacen del navegador. Y esa clave NO dice «la pantalla esta tapada
//  ahora»: dice «la tapo alguien alguna vez». `components/BloqueoPantalla` solo la borra cuando el
//  bloqueo de pantalla esta ENCENDIDO (`minutos > 0`), a proposito, para no dejar a nadie fuera de
//  la aplicacion mientras llega la configuracion. Con el bloqueo apagado —o antes de saber cuantos
//  minutos son— la marca se queda pegada, la pantalla NO esta tapada, y la puerta la leia como que
//  si: se cerraba en su primer latido, que es cada 15 segundos. Justo lo que el veia.
//
//  LA REGLA: el estado del candado se PUBLICA aqui, en memoria, y lo publica el unico que lo sabe
//  (la pantalla de bloqueo, en el mismo sitio en que se tapa y se destapa). La clave del almacen se
//  queda para lo que si es suyo: contarselo a las OTRAS pestañas y sobrevivir a un F5. Quien
//  necesite saber si la pantalla esta tapada AHORA pregunta a `pantallaBloqueada()`.
let _pantallaTapada = false;
export function marcarPantallaBloqueada(v) { _pantallaTapada = !!v; }
export function pantallaBloqueada() { return _pantallaTapada; }

// ── Y LA TERCERA VEZ HABRIA SIDO LA PEOR: «ESTOY DENTRO DE LA CLINICA 7» ────────────────────
// Cuando alguien de soporte entra en una clinica cliente, el navegador guarda AQUI en que clinica
// esta, y `services/api` le pone esa clinica a TODAS las peticiones (la cabecera `X-Clinica-Id`).
// Es, con diferencia, el resto de sesion mas peligroso que puede quedarse pegado: si sobreviviera
// a un cierre de sesion, la siguiente persona que entrase en ese ordenador —y que tambien fuera de
// plataforma— arrancaria trabajando DENTRO de la clinica de otro sin haberlo pedido, creyendo que
// mira sus propios datos. Con datos de pacientes eso no es una molestia, es escribir en la ficha
// equivocada. Por eso la clave se declara aqui, en la lista unica, y no en `api.js`: entrar con
// credenciales es empezar de cero, tambien en esto.
export const CLAVE_CLINICA_VISITADA = 'soporte_clinica_visitada';

// (5-oct-2026) LA SESIÓN DE BIANGO GUARDADA al entrar en una clínica de demostración como su dirección
// (services/demoComoDireccion): es una credencial de plataforma esperando en este navegador, así que muere con la sesión,
// como todo lo de aquí. Cerrar sesión dentro de la demo no deja la de Biango olvidada.
export const CLAVE_SESION_BIANGO = 'biango_sesion_guardada';

export const CLAVES_SESION = ['token', 'user', 'ver_como_rol', 'ver_como_usuario',
  CLAVE_CLINICA_VISITADA, CLAVE_BLOQUEO_MARCA, CLAVE_BLOQUEO_ACTIVO];
CLAVES_SESION.push(CLAVE_SESION_BIANGO);

// ── Y LA CUARTA VEZ FUE LA QUE NO ESTABA EN NINGUNA CLAVE ───────────────────────────────────
//
//  MEDIDO, no supuesto. `services/api` guarda EN MEMORIA (una variable del modulo, no una clave de
//  `localStorage`) el aviso de «tu acceso a X ha terminado», y mientras ese aviso vive PARA todas
//  las peticiones que habrian llevado la cabecera de la clinica visitada — que es lo correcto: lo
//  que hay en pantalla es un formulario de OTRA clinica y reintentar lo guardaria en la propia.
//
//  Pero `limpiarSesion()` solo alcanzaba a `localStorage`, y cerrar sesion NO recarga la pagina (es
//  un cambio de estado de React). Reproducido con el `services/api` y el axios de verdad: tras el
//  corte, cerrar sesion y volver a entrar CON OTRA CUENTA —una recepcionista normal, que no es de
//  plataforma y nunca ha visitado ninguna clinica— dejaba TODAS sus peticiones paradas en el
//  navegador (status 0, ni escrituras ni lecturas) y le pintaba arriba «Se ha terminado tu acceso a
//  CLINICA DEL VECINO», el nombre de una clinica que no es la suya. O sea: la aplicacion muerta y el
//  nombre de otro cliente, para la persona siguiente que se sienta en ese ordenador.
//
//  LA REGLA, ENTONCES: «la sesion» no son solo las claves guardadas. Lo que se apoya en la sesion y
//  vive en memoria se APUNTA AQUI y se olvida en la misma limpieza, para que ningun sitio de llamada
//  tenga que acordarse: `logout()`, `login()` y el interceptor del 401 llaman los tres a
//  `limpiarSesion()`, y con esto los tres quedan cubiertos de una vez. Una segunda limpieza escrita
//  en otro fichero es, otra vez, como volveria a pasar.
const _olvidos = new Set();

/** Apunta algo que vive EN MEMORIA y tiene que morir con la sesion. Devuelve como darse de baja. */
export function alLimpiarSesion(fn) {
  if (typeof fn !== 'function') return () => {};
  _olvidos.add(fn);
  return () => { _olvidos.delete(fn); };
}

export function limpiarSesion() {
  // Una sesion que se va no deja el candado puesto para la siguiente: entrar con credenciales es
  // prueba mas fuerte que el desbloqueo, igual que con las claves de abajo.
  _pantallaTapada = false;
  for (const k of CLAVES_SESION) {
    try { localStorage.removeItem(k); } catch (_) { /* modo privado, cuota, etc. */ }
  }
  // DESPUES de borrar las claves, para que quien escuche lea ya el estado limpio. Un olvido que
  // reviente no puede impedir los demas: la sesion se limpia entera o no se limpia.
  for (const fn of [..._olvidos]) {
    try { fn(); } catch (_) { /* un olvido roto no puede dejar media sesion pegada */ }
  }
}
